export default __webpack_public_path__ + "static/media/vintage65g-1.4f4dc5ac.jpg";